module.exports = __webpack_public_path__ + "static/media/Remove.f7008c43.svg";